import styled from "styled-components";

import { determineSideNavColor } from "../utils/Helpers";

export const MobileNavArea = styled.nav`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: ${(props) => props.theme.sideBgColor};
  overflow-x: auto;
  @media (min-width: 769px) {
    display: none;
  }
`

export const NavItemsUl = styled.ul`
  margin: unset;
  padding: unset;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

export const NavItem = styled.li`
  & {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    padding: 15px 15px 10px 15px;
    cursor: pointer;
    height: 100%;
    color: ${(props) => determineSideNavColor(props.$active, props.theme)};
    //transition: all 0.2s ease-in-out;
    opacity: ${(props) => (props.$active ? "0.975" : "1")};
    background-color: ${(props) =>
	props.active ? props.theme.bgColor : "inherit"};
    border-bottom: ${props => props.$active ? `5px solid ${props.theme.vsiPupil}` : null}
  }

  &:hover {
    opacity: 0.7;
    background-color: ${(props) => props.theme.bgColor};
    color: ${(props) => determineSideNavColor(true, props.theme)};
  }
`;

export const Icon = styled.i`
  font-size: 1.5em;
`;

export const NavTitle = styled.h6`
  max-width: 60px;
  text-align: center;
  margin: 2px 0 0;
  font-size: 0.7em;
`;
